/*
 * Copyright © 2021, CodeVision. All rights reserved.
 *
 * This file was generated by Codevision's stub generator
 */

export enum UserRole {
  SUPERADMIN = 0,
  ADMIN = 1,
  CUSTOMER = 2,
  WORKER = 3,
  PAWORKSHOPMANAGER = 4,
  PASIMPLEBOOKING = 5,
  PAEXTENDEDBOOKING = 6,
}

export namespace UserRole {
  export function values() {
    return Object.keys(UserRole).filter((type) => isNaN(type as any) && type !== 'values');
  }
}
